 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTMLCOVER from '@/components/html/cover'
 import HTML03_COPYRIGH from '@/components/html/03_Copyrigh'
 import HTML02_TITLE_PA from '@/components/html/02_Title_Pa'
 import HTML01_ALSO_BY from '@/components/html/01_Also_by'
 import HTML04_CONTENTS from '@/components/html/04_Contents'
 import HTML05_ACKNOWLE from '@/components/html/05_Acknowle'
 import HTML06_THE_GOLD from '@/components/html/06_THE_GOLD'
 import HTML07_LION_HUN from '@/components/html/07_LION_HUN'
 import HTML08_PANTING from '@/components/html/08_PANTING'
 import HTML09_SEETHING from '@/components/html/09_SEETHING'
 import HTML10_OH_FOR_A from '@/components/html/10_OH_FOR_A'
 import HTML11_FREUD__A from '@/components/html/11_FREUD__A'
 import HTML12_HOW_TO_G from '@/components/html/12_HOW_TO_G'
 import HTML13_FURTHER from '@/components/html/13_FURTHER'
 import HTML14_PHOTO_CR from '@/components/html/14_PHOTO_CR'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/04_Contents",
 			"name" : "html/04_Contents",
 			"component" : HTML04_CONTENTS
 		},
 		{
 			"path" : "/html/05_Acknowle",
 			"name" : "html/05_Acknowle",
 			"component" : HTML05_ACKNOWLE
 		},
 		{
 			"path" : "/html/06_THE_GOLD",
 			"name" : "html/06_THE_GOLD",
 			"component" : HTML06_THE_GOLD
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js